import { pushTo } from '@app/core/routing';
import { useAvailableSocialExportSources } from '@app/modules/fragments/hooks/useAvailableSocialExportSources';
import { routeGenerator } from '@app/modules/fragments/routing/FragmentsRoutes';
import { useFragment } from '@app/modules/fragments/screens/view/hooks/useFragment';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useAvailableSocialExportPlatformsForStation } from '@app/modules/social-export/hooks/useAvailableSocialExportPlatformsForStation';
import { usePlatformMediaLimitsIndications } from '@app/modules/social-export/hooks/usePlatformMediaLimitsIndications';
import { PublishPlatformDropdown } from '@app/modules/social-export/publish';

/**
 * "Publicar en" menu for fragments; navigates to the fragment upload screen for the chosen platform.
 */
export function SocialExportPublishDropdown() {
  const { fragment, durationMs } = useFragment();
  const { platforms: availablePlatforms } = useAvailableSocialExportPlatformsForStation(
    fragment.stationId,
  );
  const { hasAvailableSources } = useAvailableSocialExportSources({
    fragmentId: fragment.id,
    stationId: fragment.stationId,
  });
  const indicationByPlatformId = usePlatformMediaLimitsIndications(
    fragment.stationId,
    availablePlatforms,
    durationMs,
  );

  const handlePlatformSelect = (platformId: string) => {
    const platform = availablePlatforms.find(
      (p: SocialPlatform) => p.id.toUpperCase() === platformId.toUpperCase(),
    );
    if (platform) {
      pushTo(routeGenerator.upload(fragment, platform));
    }
  };

  return (
    <PublishPlatformDropdown
      platforms={availablePlatforms}
      disabled={!hasAvailableSources}
      indicationByPlatformId={indicationByPlatformId}
      onSelectPlatform={handlePlatformSelect}
    />
  );
}
